import {css, Theme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {calculateRemSize, ml, mt, mv, positionRelative, zIndex} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";

export const CreditRatingHeader = () => {
    const h1Text = (
        <>
            Kalkulator zdolności kredytowej.
            <span css={highlight}>
                <span css={[zIndex(10), positionRelative]}> Sprawdź już teraz</span>
            </span>
        </>
    );
    return (
        <Container as="section" css={mt(2)}>
            <Text
                align="center"
                as="h1"
                fontFamily="secondary"
                variant="headline_0"
                css={headingStyle}
                dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.TITLE}
            >
                {h1Text}
            </Text>

            <Text align="center" variant="body_copy_0" css={mv(5)} dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.SUBTITLE}>
                Zastanawiasz się, jak sprawdzić zdolność kredytową? Wprowadź podstawowe dane i umów się na rozmowę.{" "}
                <strong>Nasz ekspert szybko i bezpłatnie wyliczy Twoją zdolność kredytową</strong> i odpowie na wszystkie Twoje pytania.
            </Text>
        </Container>
    );
};

const headingStyle = css`
    font-weight: 400;
`;

const highlight = (theme: Theme) => css`
    ${mt(0.5)};
    ${ml(0.5)};
    display: inline-block;
    color: ${theme.globals.text.color};
    position: relative;

    ::before {
        content: "";
        background-color: ${theme.colors.primary};
        width: calc(100% + ${calculateRemSize()});
        height: 4rem;
        position: absolute;
        top: -50%;
        transform: translateY(50%);
        left: -${calculateRemSize(0.5)};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${mt(0)};

        ::before {
            height: 4.8rem;
            top: ${calculateRemSize(0.5)};
            transform: none;
        }
    }
`;
import {css, Theme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {calculateRemSize, ml, mt, mv, positionRelative, zIndex} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";

export const CreditRatingHeader = () => {
    const h1Text = (
        <>
            Kalkulator zdolności kredytowej.
            <span css={highlight}>
                <span css={[zIndex(10), positionRelative]}> Sprawdź już teraz</span>
            </span>
        </>
    );
    return (
        <Container as="section" css={mt(2)}>
            <Text
                align="center"
                as="h1"
                fontFamily="secondary"
                variant="headline_0"
                css={headingStyle}
                dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.TITLE}
            >
                {h1Text}
            </Text>

            <Text align="center" variant="body_copy_0" css={mv(5)} dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.SUBTITLE}>
                Zastanawiasz się, jak sprawdzić zdolność kredytową? Wprowadź podstawowe dane i umów się na rozmowę.{" "}
                <strong>Nasz ekspert szybko i bezpłatnie wyliczy Twoją zdolność kredytową</strong> i odpowie na wszystkie Twoje pytania.
            </Text>
        </Container>
    );
};

const headingStyle = css`
    font-weight: 400;
`;

const highlight = (theme: Theme) => css`
    ${mt(0.5)};
    ${ml(0.5)};
    display: inline-block;
    color: ${theme.globals.text.color};
    position: relative;

    ::before {
        content: "";
        background-color: ${theme.colors.primary};
        width: calc(100% + ${calculateRemSize()});
        height: 4rem;
        position: absolute;
        top: -50%;
        transform: translateY(50%);
        left: -${calculateRemSize(0.5)};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${mt(0)};

        ::before {
            height: 4.8rem;
            top: ${calculateRemSize(0.5)};
            transform: none;
        }
    }
`;
